import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AppBaseComponent } from '../../app-base.component';
import { EvaluationTemplateQuestionGroupDto } from '@proxy/templates';

@Component({
    selector: 'app-evalation-template-header',
    templateUrl: './evalation-template-header.component.html',
    standalone: false
})
export class EvaluationTemplateHeaderComponent extends AppBaseComponent {

  readonly weighingLabel = this.l('::Weighing');
  readonly weighingsLabel = this.l('::Weighings');
  readonly addGroupLabel = this.l('::AddGroup');

  @Input() showWeighingButton: boolean;
  @Input() showAddGroupButton: boolean;
  @Input() questionGroupsAdded: EvaluationTemplateQuestionGroupDto[] = [];
  @Input() unsavedGroup: boolean;

  @Output() triggeredWeighing = new EventEmitter<void>();
  @Output() triggeredAddGroup = new EventEmitter<void>();

  visible = false;
  weighing = 0;
  totalWeighing = 0;
  templateQuestionGroups: EvaluationTemplateQuestionGroupDto[] = [];

  onClickWeighing(): void {
    this.changeModalVisibility();
    this.calculateTotalWeighing();
    this.triggeredWeighing.emit();
  }

  calculateTotalWeighing(){
    this.totalWeighing = this.questionGroupsAdded.reduce((total, group) => total + (group.weighing || 0), 0);
  }

  onClickAddGroup(): void {
    this.triggeredAddGroup.emit();
  }

  private changeModalVisibility(): void {
    this.visible = !this.visible;
  }

  loadQuestionGroups(): void {
    this.templateQuestionGroups = this.questionGroupsAdded.filter(
      (group) => group?.questionGroup?.id
    );
  }
}
